import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import QueryHistoric from "./query-historic/query-historic";
import { Card, CardContent } from "@/components/ui/card";
import QueryFavorite from "./query-favorite/query-favorites";

const QueryRequestTabs = () => {
  return (
    <Card className="w-full shadow-none">
      <CardContent className="p-6">
        <Tabs defaultValue="historic" className="w-full">
          <TabsList className="grid w-full grid-cols-2 rounded-lg bg-white border p-1">
            <TabsTrigger
              value="historic"
              className="rounded-md transition-all data-[state=active]:bg-black data-[state=active]:text-white data-[state=active]:shadow-sm"
            >
              Histórico
            </TabsTrigger>
            <TabsTrigger
              value="favorites"
              className="rounded-md transition-all data-[state=active]:bg-black data-[state=active]:text-white data-[state=active]:shadow-sm"
            >
              Favoritos
            </TabsTrigger>
          </TabsList>
          <TabsContent value="historic" className="mt-6">
            <QueryHistoric />
          </TabsContent>
          <TabsContent value="favorites" className="mt-6">
            <QueryFavorite />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default QueryRequestTabs;
